import type { PosTab } from './pos-shell-page.types';

// The full set of PosShell flags that decide whether a hard refresh may run now.
export type PosSafeZoneState = {
  activeTab: PosTab;
  areaMode: 'view' | 'edit';
  selectedOrderId: number | null;
  isPaymentScreenOpen: boolean;
  isReceiptScreenOpen: boolean;
  // Post-payment close screen (success fallback or printer picker); a refresh loses the step.
  isPostPaymentScreenOpen: boolean;
  // Cash-overpay change dialog; can outlive the order selection once the order closes.
  hasCashChangeDialog: boolean;
  isGuestNameEditOpen: boolean;
  isReceiptPreviewOpen: boolean;
  isSettingTip: boolean;
  isDinersNumPadOpen: boolean;
  isSettingsSubFlowActive: boolean;
  // Any hub-launched modal outside the main tabs (happy-hour, VAT edit, accountant/X/Z/worker
  // reports, opening-cash) — these open via their own flags, not settingsModalKey.
  hasHubModalOpen: boolean;
  hasManualCreditTarget: boolean;
  hasTapOnPhoneTarget: boolean;
  hasSelectionModal: boolean;
  hasPaymentOveragePrompt: boolean;
  hasPaymentZeroTotalPrompt: boolean;
  hasCashDrawerPrompt: boolean;
  hasCancelTableConfirm: boolean;
  transferMode: boolean;
  mergeMode: boolean;
  splitMergeOrderPk: number | null;
  hasMergeConflict: boolean;
  hasInFlightWrite: boolean;
};

// Architectural summary: True only on a main tab at rest with nothing active; else refresh defers.
export function isPosSafeZone(state: PosSafeZoneState): boolean {
  const onRestTab =
    (state.activeTab === 'areas' && state.areaMode === 'view') ||
    state.activeTab === 'orders' ||
    state.activeTab === 'limit-items';
  if (!onRestTab) {
    return false;
  }
  if (state.selectedOrderId !== null) {
    return false;
  }
  const blocked =
    state.isPaymentScreenOpen ||
    state.isReceiptScreenOpen ||
    state.isPostPaymentScreenOpen ||
    state.hasCashChangeDialog ||
    state.isGuestNameEditOpen ||
    state.isReceiptPreviewOpen ||
    state.isSettingTip ||
    state.isDinersNumPadOpen ||
    state.isSettingsSubFlowActive ||
    state.hasHubModalOpen ||
    state.hasManualCreditTarget ||
    state.hasTapOnPhoneTarget ||
    state.hasSelectionModal ||
    state.hasPaymentOveragePrompt ||
    state.hasPaymentZeroTotalPrompt ||
    state.hasCashDrawerPrompt ||
    state.hasCancelTableConfirm ||
    state.transferMode ||
    state.mergeMode ||
    state.splitMergeOrderPk !== null ||
    state.hasMergeConflict ||
    state.hasInFlightWrite;
  return !blocked;
}
